import Env from '../base/env'
import Channels from '../base/channels.js'


export default class LangSelector
{
  constructor()
  {
    this.view = document.getElementById('jsLangSelector--view');
    this.$langUpdaters = document.querySelectorAll('.jsLangUpdate')
  }

  update() {
    const url = window.location.href
    let strFind
    if(config.lang == 'en') {
      strFind = '/en/'
    } else if(config.lang == 'es') {
      strFind = '/es/'
    } else if(config.lang == 'de') {
      strFind = '/de/'
    } else if(config.lang == 'jp') {
      strFind = '/jp/'
    } else if(config.lang == 'zh') {
      strFind = '/zh/'
    } else {
      strFind = '/fr/'
    }
    const urlFr = url.replace(strFind,'/fr/')
    const urlEn = url.replace(strFind,'/en/')
    const urlEs = url.replace(strFind,'/es/')
    const urlDe = url.replace(strFind,'/de/')
    const urlJp = url.replace(strFind,'/jp/')
    const urlZh = url.replace(strFind,'/zh/')
    for(let $update of this.$langUpdaters) {
      const dataLang = $update.getAttribute('data-lang')
      if(dataLang == 'fr') {
        $update.setAttribute('href',urlFr)
      }
      if(dataLang == 'en') {
        $update.setAttribute('href',urlEn)
      }
      if(dataLang == 'es') {
        $update.setAttribute('href',urlEs)
      }
      if(dataLang == 'de') {
        $update.setAttribute('href',urlDe)
      }
      if(dataLang == 'jp') {
        $update.setAttribute('href',urlJp)
      }
      if(dataLang == 'zh') {
        $update.setAttribute('href',urlZh)
      }

    }
  }

  toggle()
  {
    Env.$html.classList.toggle('langSelector--isOpened')
  }
}
